import { render } from "./BarLayout.vue?vue&type=template&id=3064c35a"
import script from "./BarLayout.vue?vue&type=script&lang=js"
export * from "./BarLayout.vue?vue&type=script&lang=js"

import "./BarLayout.vue?vue&type=style&index=0&id=3064c35a&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__